import { useQuery } from '@tanstack/react-query';
import type { ChatRuntimeDefaultsDTO } from '@shared/schemas/runtime-settings';
import { getChatRuntimeDefaults } from '../services/chat.api';

export const chatRuntimeDefaultsQueryKey = ['chat', 'runtime-defaults'] as const;

export function resolveChatRuntimeWebSearchDefault(
  defaults: ChatRuntimeDefaultsDTO | undefined,
) {
  return defaults?.newConversationWebSearchDefaultEnabled ?? true;
}

export function useChatRuntimeDefaults(enabled: boolean) {
  return useQuery({
    enabled,
    queryFn: getChatRuntimeDefaults,
    queryKey: chatRuntimeDefaultsQueryKey,
  });
}
